const selectedHost = '__auto__' === '__auto__' ? location.host : '__auto__';
const selectedProtocol = '__auto__' === '__auto__' ?  location.protocol : '__auto__:';
const wsProtocol = selectedProtocol === 'https:' ? 'wss:' : 'ws:';

export default {
  production: true,
  apiUri: `${selectedProtocol}//${selectedHost}`,
  wsUri: `${wsProtocol}//${selectedHost}`,
  apiPrefix: '/api/internal/',
  redirect404: '' ? '' : `${location.protocol}//${location.host}`,
  redirect401: '' ? '' : `${location.protocol}//${location.host}`,
  sentry_dsn: '',
  sentry_env: '',
};
